var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "osResHeader padTop txtC padBX",
        staticStyle: { "background-color": "#ededed", "max-width": "none" }
      },
      [
        _c("div", [
          _c("img", {
            staticStyle: {
              "max-width": "159px",
              "min-width": "80px",
              width: "26.6%"
            },
            attrs: {
              src: require("@/assets/images/relay-event/logo_01.png"),
              alt: "Artistry Skin Nutrition (로고)"
            }
          })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fntH5 marTML" }, [
          _vm._v("A7070과 함께 시작하는"),
          _c("br", { staticClass: "moOnly" }),
          _vm._v(" 건강한 안티에이징 루틴 만들기")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fntH1 fntM marTL" }, [
          _c("strong", { staticStyle: { color: "#303030" } }, [
            _vm._v("스킨 뉴트리션")
          ]),
          _vm._v(" "),
          _c("br", { staticClass: "moOnly" }),
          _vm._v(" "),
          _c("strong", { staticStyle: { color: "#ec2020" } }, [
            _vm._v("릴레이 이벤트")
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fntH6 light marTML" }, [
          _vm._v("선착순 이벤트 참여하고 스킨 뉴트리션이"),
          _c("br", { staticClass: "moOnly" }),
          _vm._v(" 준비한 선물을 받아보세요!")
        ]),
        _vm._v(" "),
        _c("picture", [
          _c("source", {
            attrs: {
              media: "(max-width:639px)",
              srcset: require("@/assets/images/relay-event/vis_m.jpg")
            }
          }),
          _vm._v(" "),
          _c("source", {
            attrs: {
              media: "(min-width:640px)",
              srcset: require("@/assets/images/relay-event/vis.jpg")
            }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "marTXM",
            attrs: {
              src: require("@/assets/images/relay-event/vis.jpg"),
              alt: "스킨 뉴트리션 제품 이미지"
            }
          })
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09dc01d7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09dc01d7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/relayevent/component/header_title.vue
// module id = null
// module chunks = 